module.exports = __webpack_public_path__ + "static/media/BBI_portrait_logo.d14e47a9.svg";